import React from 'react';
import  '../styles/button.css';

const Button = ({name, onClick, styles, disabled }) => {
  return (
    <button type="button"  className='btn btn-primary ' onClick={onClick} style={styles} disabled={disabled}> {name} </button>
  )
}

export default Button;